module.exports = __webpack_public_path__ + "static/media/BG_66.9cd37493.png";